export default {"src":"/_next/static/media/clock.61f3dc0b.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};